function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffa7c0",
  d: "M59.65 41.31c-5.498-1.291-8.709-8.777-12.95-11.61-4.4-2.9-11.6-3.8-16.1-.3-2.1 1.6-3 3.8-3.5 5.2-.5.2-1.2.3-1.8-.1-.5-.3-1.1-1.2-.8-4.2.5-5.1 2.3-5.9 2-9.2-.3-2.4-1.4-4-2-4.8-1-1.3-2.5-3.5-4.7-3.3-1.7.1-2.8 1.5-3.1 2-1.8 0-3.2 1.1-3.7 2.5-.7 2.1 1.2 4.3 1.7 4.2.3-.1.1-1 .6-2.3.4-.9 1.1-.8 1.6-1.2 1 0 1.8.8 2.8.8.6 0 1.9-.7 1.9-.7.597 1.671 1.542 2.286-.866 5.933-.5 1.2-1.434 6.867-.234 10.17.3 1 1.016 3.861 5.216 5.061.5.7 1.884.94 3.484 1.739 2.4 1.3 4.6 1.1 5.5 1 6.543 4.17 18.53 1.505 24.95-.891z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "m36.34 54.67 2.1-2.1 14.41-4.391-10.89-3.743m-2.445.181c1.2 3.2 2.894 10.59 2.894 10.59s-.4 4.1-.8 7.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.63 24.69c-.5 1.2-2.366 6.681-1.166 9.981.3 1 1.219 4.228 5.419 5.428 2.472 2.046 5.248 2.796 8.65 2.4 1.15 1.2 6.75 2.1 9.25 2 4.5-.2 7.296-2.768 15.6-2.104-6.324-6.558-8.521-8.792-12.62-11.53-4.4-2.9-11.87-5.068-16.37-1.568-2.1 1.6-1.818 4.41-3.5 5.2-.5.2-1.2.3-1.8-.1-.5-.3-1.1-1.2-.8-4.2.5-5.1 2.3-5.9 2-9.2-.3-2.4-1.4-4-2-4.8-1-1.3-2.5-3.5-4.7-3.3-1.7.1-2.8 1.5-3.1 2-1.8 0-3.2 1.1-3.7 2.5-.7 2.1 1.2 4.3 1.7 4.2.3 0 1.7-3.2 2.5-3.1 1 0 1.5 1.3 2.5 1.4 1.3.1 1.9-.7 1.9-.7"
}));

var SvgFlamingo = function SvgFlamingo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlamingo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flamingo.5ba966e2.svg";
export { ForwardRef as ReactComponent };